import {
  DokumentQuelldaten,
  DokumentVorschau,
  DokumentVersandArt,
} from '@core/domain';
import { useMutation } from '@tanstack/react-query';

import { useApiClient } from './useApiClient';

export interface DokumentVorschauRequest {
  dokumentQuelldaten: DokumentQuelldaten;
  versandArt: DokumentVersandArt;
}

export const useDokumentVorschau = () => {
  const { axiosInstance } = useApiClient();

  return useMutation<DokumentVorschau, unknown, DokumentVorschauRequest>({
    mutationFn: async (payload) => {
      const response = await axiosInstance.post<DokumentVorschau>(
        '/dokumente/vorschau',
        payload,
      );
      return response.data;
    },
  });
};
